import React from "react"

import { Floor } from "shared/types/Floor"

import { NewFloorOverlay } from "./NewFloorOverlay"
import { useNewFloorOverlayModel } from "./model/useNewFloorOverlayModel"

export interface NewFloorOptions {
  floor?: Partial<Floor>
  hideProject?: boolean
}

export interface NewFloorOverlayPayload extends NewFloorOptions {
  projectID: string
}

export interface NewFloorOverlayConnectorProps {
  payload: NewFloorOverlayPayload
}

export const NewFloorOverlayConnector = React.memo(
  (props: NewFloorOverlayConnectorProps) => (
    <NewFloorOverlay autoFocus {...useNewFloorOverlayModel(props)} />
  )
)

NewFloorOverlayConnector.displayName = "NewFloorOverlayConnector"

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    NEW_FLOOR_OVERLAY: NewFloorOverlayPayload
  }
}
